import { Container } from "react-bootstrap";
import { userManager } from "../authService";

export default function Login() {
  userManager.signinRedirect();

  return <Container>Redirecting...</Container>;
}
